<template>
<div>
  <div class="title-bar title-h3 mr-r15">
    {{ title }} 키 트랜잭션 목록
  </div>
  <el-row class="title-bar" type="flex" justify="space-between">
    <div class="vertical-center-box">
      <el-button class="mr-r4" type="primary" :disabled="!isNodeFlag" @click="addKeyTrs">추가</el-button>
      <el-button :disabled="!checkChangeFlag" class="mr-r4" @click="deleteKeyTrs">삭제</el-button>
    </div>
    <div class="vertical-center-box">
      <el-button :disabled="!checkChangeFlag" type="secondary" @click="openChangePopup" class="mr-r4">비즈니스변경</el-button>
      <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </div>
  </el-row>
  <el-row class="mr-b20">
    <el-table-wrapper v-loading="isLoading" ref="keyTrsTable" remote pagination show-custom-header :total="total" :column-default="columnDefault" :show-search-tool="showSearchTool" row-class-name="c-dblclick"
      :data="trsDataList" :columns="keyTrsListColumns" @selection-change="selectedKeyTrsChange" @condition-change="loadKeyTrsList" @row-dblclick="onDbclickRow" />
  </el-row>
  <div>
    <w-group-change-popup ref="groupChangePopup" current-tree-type="biz" :selected-config-treekey="currentNode.treeKey" :selection-nodes="selectedKeyTrs" @reloadData="reloadAllData" />
    <w-add-trs-key-popup ref="addTrsKeyPopup" :biz-id="currentNode.bizId" @reload="reloadAllData" />
    <w-update-key-trs-popup ref="updatePopup" @reloadData="loadKeyTrsList" />
  </div>
</div>
</template>

<script>
import { isEmpty, isNil, map } from 'lodash';
import { columnDefault } from '@/constants/table';
import { EMPTY_TEXT } from '@/utils/string';
import msgUtil from '@/utils/message';
import ApmSettingAPI from '@/api/settings/apm/apm-setting';
import WGroupChangePopup from '../components/popup/GroupChangePopup';
import WAddTrsKeyPopup from '../components/popup/AddTrsKeyPopup';
import WUpdateKeyTrsPopup from '../components/popup/UpdateKeyTrsPopup';

export default {
  name: 'WKeyTrsSettingView',
  components: {
    WGroupChangePopup,
    WAddTrsKeyPopup,
    WUpdateKeyTrsPopup,
  },
  props: {
    currentNode: Object,
  },
  data() {
    return {
      columnDefault,
      selectedKeyTrs: [],
      selectedRow: null,
      checkChangeFlag: false,
      isLoading: false,
      showSearchTool: false,
      trsDataList: [],
      total: 0,
      keyTrsListColumns: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'keyTrsName',
          label: '키 트랜잭션 명',
          searchable: true,
          sortable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'webSvcUrl',
          label: '웹 서비스 URL',
          searchable: true,
          sortable: true,
          remoteProp: 'web_svc_url',
        },
        {
          prop: 'webSvcMethod',
          label: '웹 서비스 메소드',
          width: 200,
          searchable: true,
          sortable: true,
          remoteProp: 'web_svc_method',
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  computed: {
    isNodeFlag() {
      return this.currentNode.type === 'group';
    },
    title() {
      if (isEmpty(this.currentNode)) {
        return null;
      }
      return this.currentNode.bizId ? `[${this.currentNode.bizName}]` : null;
    },
  },
  watch: {
    currentNode: {
      immediate: true,
      handler(currentNode) {
        if (isEmpty(currentNode) || currentNode.type !== 'group') {
          return;
        }

        this.$nextTick(() => {
          this.loadKeyTrsList();
        });
      },
    },
  },
  methods: {
    getTableValueAfterCheckEmpty(row, column, value) {
      return isEmpty(value) ? EMPTY_TEXT : value;
    },
    /**
     * [loadKeyTrsList 비즈니스 아이디에 따른 키 트랜잭션 목록을 조회한다.]
     * @author yelim
     */
    loadKeyTrsList() {
      if (!isNil(this.currentNode.bizId)) {
        this.isLoading = true;
        const tableParams = this.$refs.keyTrsTable.getParameter();
        ApmSettingAPI.getKeyTrsSettingList({ bizId: this.currentNode.bizId, ...tableParams }).then((response) => {
          this.isLoading = false;
          if (response.data.success) {
            this.trsDataList = response.data.data;
            this.total = response.data.total;
          } else {
            this.trsDataList = [];
            this.total = 0;
          }
        });
      }
    },
    /**
     * [selectedKeyTrsChange 선택된 키트랜잭션 리스트를 저장한다.]
     * @author yelim
     */
    selectedKeyTrsChange(row) {
      this.selectedKeyTrs = row;
      if (this.isNodeFlag && row.length > 0) {
        this.checkChangeFlag = true;
      } else {
        this.checkChangeFlag = false;
      }
    },
    /**
     * [openChangePopup 노드가 속한 그룹의 정보를 바꾸기 위한 팝업 오픈]
     * @author yelim
     */
    openChangePopup() {
      this.$refs.groupChangePopup.open();
    },
    reloadAllData() {
      this.loadKeyTrsList();
      this.$emit('reloadTree');
    },
    /**
     * [addKeyTrs 키 트랜잭션 등록 팝업 오픈]
     * @author yelim
     */
    addKeyTrs() {
      this.$refs.addTrsKeyPopup.open();
    },
    /**
     * [deleteKeyTrs 키 트랜잭션 삭제]
     * @author yelim
     */
    deleteKeyTrs() {
      const deleteTrsIdList = map(this.selectedKeyTrs, 'keyTrsId');

      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        ApmSettingAPI.deleteKeyTrs(deleteTrsIdList).then((response) => {
          if (response.data.success) {
            this.reloadAllData();
          }
          this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '키 트랜잭션', response.data.success));
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '키 트랜잭션', false));
        });
      });
    },
    /**
     * 키트랜잭션명을 변경할 팝업창을 띄운다.
     * @param  {[type]} record [description]
     * @return {[type]}        [description]
     * @author jda
     */
    onDbclickRow(record) {
      const info = {
        bizName: this.currentNode.bizName,
        ...record,
      };
      this.$refs.updatePopup.open(info);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/apm/ConfigSettings/key-transaction/KeyTrsSettingView.vue